<template lang='pug'>
  - const now = new Date();
  .container.mb-4
    .row.margined
      | Copyright © 2010-#{now.getFullYear()} Hawaii Canine Assistance Network
</template>

<script>
export default {
  name: 'Footer'
};
</script>

<style scoped>
  .margined {
    margin-left: 10px;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue